<template>
  <div class="service-content" v-animate-on-scroll="'animate__fadeInUp'">
    <img src="@/assets//images/icon-4.png" alt="" class="icon-image" />
    <div class="service-row">
      <div
        class="service-flex"
        v-for="(item, index) in coopList"
        :key="index"
        @click="openLink(item)"
      >
        <img :src="item.cover" alt="" class="image" />
        <div class="title">{{ item.articleName }}</div>
      </div>
    </div>
    <div class="m-bot">
      <el-pagination
        background
        layout="prev, next"
        :page-size="pageSize"
        :total="pageCount"
        @current-change="changePageClick"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getArticlePage } from '@/api/home/home.js'
export default {
  data() {
    return {
      coopList: [],
      pageCount: 0,
      pageSize: 8
    }
  },
  created() {
    this.getCoopPage(106)
  },
  methods: {
    getCoopPage(categoryCode, page = 1) {
      getArticlePage({
        page: page,
        limit: 8,
        categoryCode: categoryCode
      }).then((res) => {
        if (!res.data) return
        this.coopList = res.data.list
        this.pageCount = Number(res.data.count)
      })
    },
    //切换页面
    changePageClick(page) {
      this.getCoopPage(106, page)
    },
    //   跳转
    openLink(item) {
      if (item.articleUrl) {
        window.open(item.articleUrl)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.service-content {
  display: flex;
  flex-direction: column;
  width: 1340px;
  margin: 64px auto 120px;

  .m-bot {
    margin-top: 24px;
    margin-bottom: 24px;

    .el-pagination {
      display: flex;
      justify-content: center;

      ::v-deep .el-icon {
        font-weight: 700;
        font-size: 28px;
      }
      ::v-deep .btn-prev {
        width: 47px;
        height: 47px;
        border-radius: 50%;
        border: 1px solid #1b56a9;
        background: #fff;
      }
      ::v-deep .btn-next {
        width: 47px;
        height: 47px;
        border-radius: 50%;
        border: 1px solid #1b56a9;
        background-color: #fff;
        margin-left: 30px;
        font-weight: 700;
        font-size: 28px;
      }

      ::v-deep .btn-prev:enabled {
        color: #1b56a9;
      }

      ::v-deep .number {
        width: 40px;
        height: 40px;
        line-height: 40px;
        border: 1px solid #e4e4e4;
        background-color: #fff;
      }

      ::v-deep .btn-next:enabled {
        color: #1b56a9;
      }

      ::v-deep .active {
        color: #fff;
        background-color: #1b56a9;
      }
      ::v-deep .btn-prev:disabled {
        border: 1px solid #e6e6e6 !important;
      }

      ::v-deep .btn-next:disabled {
        border: 1px solid #e6e6e6 !important;
      }
    }
  }
  .service-row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    .service-flex {
      display: flex;
      flex-direction: column;
      background: #fff;
      box-shadow: -1px 4px 27.9px 0 rgba(111, 108, 108, 0.05);
      width: 299px;
      height: 168px;
      padding: 14px 24px 16px;
      margin: 24px 0;
      margin-right: 48px;
      box-sizing: border-box;
      cursor: pointer;

      .title {
        height: 34px;
        line-height: 34px;
        color: #333;
        font-size: 20px;
        font-weight: bold;
        text-align: center;
        margin-top: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      .image {
        width: 236px;
        height: 88px;
        object-fit: contain;
        margin: 0 auto;
      }
    }
    .service-flex:nth-child(n + 5) {
      margin-top: 34px;
    }
    .service-flex:nth-child(4n + 4) {
      margin-right: 0;
    }
  }
  .icon-image {
    width: 250px;
    height: 64px;
    margin: 0 auto 34px;
  }
}

// 手机端css
.mobile-content {
  .service-content {
    width: 345px;
    margin: 32px auto 60px;
    .m-bot {
      margin: 12px 0 0;
      .el-pagination {
        ::v-deep .el-icon {
          font-size: 16px;
        }

        ::v-deep .btn-prev {
          width: 35px;
          height: 35px;
        }
        ::v-deep .btn-next {
          width: 35px;
          height: 35px;
          margin-left: 20px;
          font-size: 16px;
        }

        ::v-deep .number {
          width: 35px;
          height: 35px;
          line-height: 35px;
          border: 1px solid #e4e4e4;
          background-color: #fff;
        }
      }
    }
    .service-row {
      .service-flex {
        width: calc(100% / 2 - 9px);
        height: auto;
        padding: 7px 12px 8px;
        margin: 12px 0;
        margin-right: 15px;
        .title {
          height: 25px;
          line-height: 25px;
          font-size: 14px;
        }
        .image {
          width: 100%;
          height: 50px;
        }
      }
      .service-flex:nth-child(2n + 2) {
        margin-right: 0;
      }
      .service-flex:nth-child(n + 2) {
        margin-top: 17px;
      }
      .service-flex:nth-child(n + 5) {
        margin-top: 0;
      }
    }
    .icon-image {
      width: 150px;
      height: 38.4px;
    }
  }
}
</style>
